var React = require('react');

function CinemaMode (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"5","y":"5","width":"150","height":"90","stroke":"white","strokeWidth":"10","key":0}),React.createElement("rect",{"x":"5","y":"5","width":"110","height":"60","stroke":"white","strokeWidth":"10","key":1})]);
}

CinemaMode.defaultProps = {"width":"24","height":"24","viewBox":"0 0 160 90","fill":"none"};

module.exports = CinemaMode;

CinemaMode.default = CinemaMode;
